<template>
  <div>
    <div v-if="!item.draggable">
      {{ item.title }}
    </div>
    <draggable
      :list="[item]"
      :group="{ name: 'items', pull: 'clone', put: false }"
      handle=".prd-treeview__handle"
      :data-meta="JSON.stringify(item.meta)"
      :data-item="JSON.stringify(item.meta.id)"
    >
      <div
        v-if="
          item.draggable || (!ActivitatIsUsed(item.meta.id) && item.draggable)
        "
        :class="{ 'green--text darken-6': ActivitatIsUsed(item.meta.id) }"
        class="ma-0 prd-treeview__handle"
      >
        {{ item.title }}
      </div>
    </draggable>
  </div>
</template>

<script>
import draggable from "vuedraggable"
export default {
  components: {
    draggable,
  },
  props: {
    item: {
      type: Object,
      required: true,
    },
    resumActivitatMetaIds: {
      type: Array,
      required: true,
    },
  },
  methods: {
    ActivitatIsUsed(id) {
      return this.resumActivitatMetaIds.includes(id)
    },
  },
}
</script>

<style scoped></style>
